import styled, { css } from "styled-components";
import { fontMixins } from "../../../styles";

export const PlansContainer = styled.div`
	display: flex;
	justify-content: center;
	margin: 30px 0 60px;
	column-gap: 7px;
`;

interface PlansItemContainerProps {
	isActive: boolean;
}

export const PlansItemContainer = styled.div<PlansItemContainerProps>`
	display: flex;
	${fontMixins(16, 400)};
	color: #989898;
	border: 1px solid #989898;
	border-radius: 7px;
	padding: 10px 20px;
	cursor: pointer;

	${(props) =>
		props.isActive &&
		css`
			font-weight: 600;
			color: #000;
			border-color: #000;
		`}
`;
